import { ApiInstance, scopedTo } from '@/lib/api'
import { isNotFound } from '@/lib/errors'
import type { Subscription } from '../types'

export const fetchSubscription = async (companyId?: string): Promise<Subscription | null> => {
  try {
    const { data } = await ApiInstance.get<Subscription | ''>('/subscriptions', scopedTo(companyId))
    return data || null
  } catch (error) {
    if (isNotFound(error)) return null
    throw error
  }
}
